import jQuery from 'jquery'

// Set up jQuery global
window.$ = window.jQuery = jQuery